module.exports = __webpack_public_path__ + "img/arrow_prev.0b743654.svg";